import { BaseQueryParams } from "../baseQuery";

export const dashboardService = BaseQueryParams(
  "dashboardService",
).injectEndpoints({
  endpoints: (builder) => ({
    getDashboard: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/migrations/dashboard${
          page ? `?page=${page}` : ""
        }&config=1`,
        method: "GET",
        params: filters,
      }),

      providesTags: () => ["DASHBOARD_SERVICE"],
      keepUnusedDataFor: 0,
    }),

    getProperties: builder.query({
      query: () => ({
        url: `/admin/migrations/dashboard/properties`,
        method: "GET",
      }),

      keepUnusedDataFor: 0,
    }),

    patchMigrationStatus: builder.mutation({
      query: ({ id, body }) => ({
        url: `/admin/migrations/${id}/statuses`,
        method: "PATCH",
        body,
      }),

      invalidatesTags: () => ["DASHBOARD_SERVICE"],
    }),
  }),
});

export const {
  useGetDashboardQuery,
  useGetPropertiesQuery,
  usePatchMigrationStatusMutation,
} = dashboardService;
